import { render, staticRenderFns } from "./AccessPoints.vue?vue&type=template&id=25ba5554&scoped=true"
import script from "./AccessPoints.vue?vue&type=script&lang=js"
export * from "./AccessPoints.vue?vue&type=script&lang=js"
import style0 from "./AccessPoints.vue?vue&type=style&index=0&id=25ba5554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ba5554",
  null
  
)

export default component.exports